var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApptoserviceconnection(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.752 7.46667C12.496 5.95733 11.184 4.8 9.59999 4.8C7.83466 4.8 6.39999 6.23467 6.39999 8C6.39999 9.76533 7.83466 11.2 9.59999 11.2C11.184 11.2 12.496 10.0427 12.752 8.53333H15.4667V7.46667H12.752ZM9.59999 10.1333C8.42133 10.1333 7.46666 9.17867 7.46666 8C7.46666 6.82133 8.42133 5.86667 9.59999 5.86667C10.7787 5.86667 11.7333 6.82133 11.7333 8C11.7333 9.17867 10.7787 10.1333 9.59999 10.1333ZM9.59999 13.3333V14.4C6.25066 14.4 3.49866 11.8133 3.22666 8.53333H0.533325V7.46667H3.22666C3.49866 4.18667 6.25066 1.6 9.59999 1.6V2.66667C6.66133 2.66667 4.26666 5.06133 4.26666 8C4.26666 10.9387 6.66133 13.3333 9.59999 13.3333Z",
    fill: "#161616"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApptoserviceconnection);
export default __webpack_public_path__ + "static/media/app to service connection.4cd2117dd93ffcdb77ccd11b1e785f83.svg";
export { ForwardRef as ReactComponent };